import React, { useCallback } from "react";
import RessourceStatusComp from "./RessourceStatusComp";
import useGetRessourceByActionId from "../../../hooks/useGetRessourceByActionId";

const DISABLED_STATUS = 4;

const RessourcesRenderComp = ({ resourceConfigId }) => {
  const { actionConfigRessources } =
    useGetRessourceByActionId(resourceConfigId);

  const renderResources = useCallback(() => {
    if (!actionConfigRessources || actionConfigRessources.length === 0) {
      return <span>Aucune ressource disponible.</span>;
    }

    return actionConfigRessources.map((ressource, index) => {
      const isDisabled = ressource.status === DISABLED_STATUS;

      return (
        <div
          className="d-flex justify-content-start gap-3 align-items-baseline"
          key={index}
          style={{ opacity: isDisabled ? 0.4 : 1 }}
        >
          <a
            href={isDisabled ? undefined : ressource.url}
            target={isDisabled ? undefined : "_blank"}
            rel="noreferrer"
            className={`text-truncate ${
              isDisabled ? "text-muted pe-none" : "link-primary"
            }`}
            style={{ pointerEvents: isDisabled ? "none" : "auto" }}
          >
            {ressource.title}
          </a>

          {!!ressource.rating && (
            <div className="d-flex align-items-baseline">
              {ressource.rating}{" "}
              <i className="bx bxs-star text-warning"></i>
            </div>
          )}

          <RessourceStatusComp status={ressource.status} />
        </div>
      );
    });
  }, [actionConfigRessources]);

  return <div>{renderResources()}</div>;
};

export default RessourcesRenderComp;
